import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	unlinkConfirmationModalTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unlinkConfirmationCancelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unlinkConfirmationConfirmButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unlinkSuccessTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewCta: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unlinkErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unlinkErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	refreshCta: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	unlinkConfirmationModalTitle: {
		id: 'issue-field-link-relationship-inline-edit-full.unlink-confirmation-modal-title',
		defaultMessage: 'Unlink {workType} {issueKey} from this work item.',
		description:
			'Unlink modal confirmation title with work item key and work item type. The work type can be values like "bug", "story", or custom types created by users. If it is not possible to include this string in a translation, the workType value can be left out',
	},
	unlinkConfirmationCancelButton: {
		id: 'issue-field-link-relationship-inline-edit-full.unlink-confirmation-cancel-button',
		defaultMessage: 'Cancel',
		description: 'Text for the button used to cancel the modal without unlinking the work item',
	},
	unlinkConfirmationConfirmButton: {
		id: 'issue-field-link-relationship-inline-edit-full.unlink-confirmation-confirm-button',
		defaultMessage: 'Unlink',
		description: 'Text for the button used to confirm unlink action',
	},
	unlinkSuccessTitle: {
		id: 'issue-field-link-relationship-inline-edit-full.unlink-success-title',
		defaultMessage: '{workType} {issueKey} has been unlinked from this work item.',
		description:
			'Title for success flag with work key and work type when work item is unlinked. The work type can be values like "bug", "story", or custom types created by users. If it is not possible to include this string in a translation, the workType value can be left out',
	},
	viewCta: {
		id: 'issue-field-link-relationship-inline-edit-full.view-cta',
		defaultMessage: 'View',
		description: 'View CTA for success flag when unlinking succeeds',
	},
	unlinkErrorTitle: {
		id: 'issue-field-link-relationship-inline-edit-full.unlink-error-title',
		defaultMessage: "We can't unlink {workType} {issueKey}",
		description:
			'Title with work type for error flag when unlinking fails. The work type can be values like "bug", "story", or custom types created by users. If it is not possible to include this string in a translation, the workType value can be left out',
	},
	unlinkErrorDescription: {
		id: 'issue-field-link-relationship-inline-edit-full.unlink-error-description',
		defaultMessage: 'Refresh the page and try again.',
		description: 'Description for error flag when unlinking fails',
	},
	refreshCta: {
		id: 'issue-field-link-relationship-inline-edit-full.refresh-cta',
		defaultMessage: 'Refresh',
		description: 'Refresh CTA for error flag when unlinking fails',
	},
});
export default messages;
